export default "__VITE_ASSET__39e353b7__"